type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastOptions {
  message: string;
  type?: ToastType;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

let container: HTMLElement | null = null;

function getContainer(): HTMLElement {
  if (container && document.body.contains(container)) return container;
  container = document.createElement('div');
  container.className = 'toast-container';
  document.body.appendChild(container);
  return container;
}

const ICONS: Record<ToastType, string> = {
  success: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
  error: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
  warning: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  info: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
};

export function showToast(opts: ToastOptions | string): void {
  const options: ToastOptions = typeof opts === 'string' ? { message: opts } : opts;
  const { message, type = 'info', duration = 4000, action } = options;

  const el = document.createElement('div');
  el.className = `toast toast-${type}`;
  el.innerHTML =
    `<span class="toast-icon">${ICONS[type]}</span>` +
    `<span class="toast-msg">${message}</span>` +
    (action ? `<button class="toast-action">${action.label}</button>` : '') +
    `<button class="toast-close">&times;</button>`;

  const dismiss = () => {
    el.classList.add('toast-exit');
    el.addEventListener('animationend', () => el.remove());
  };

  el.querySelector('.toast-close')!.addEventListener('click', dismiss);
  if (action) {
    el.querySelector('.toast-action')!.addEventListener('click', () => {
      action.onClick();
      dismiss();
    });
  }

  getContainer().appendChild(el);
  if (duration > 0) setTimeout(dismiss, duration);
}
